// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".video-wrap[data-v-0fcbbfe2] :deep(.xgplayer-skin-default){background:transparent}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
